import { Alert } from '@/global/components/Alert'
import { Button } from 'global/components/Button'
import Dialog from 'global/guides/Dialog'
import { useFolhaPagamentoOutletContext } from 'pages/FolhaPagamento'
import { useState } from 'react'
import {
    ExportacaoFolhaSchema,
    TPagamentoFolha,
    integracaoFolha,
} from 'service/api/endpoints/integracao-folha'
import { toast } from 'sonner'
import { useStore } from 'store'
import FormExportacaoTxt from '../form/FormExportacaoTxt'

export default function ExportacaoTxt() {
    const { data, competencia } = useFolhaPagamentoOutletContext()
    const empresaId = useStore(state => state.companyId)
    const empresa = useStore(state => state.company)

    const { data: historico } = integracaoFolha.historico.useFetch({
        queryParams: {
            empresaId,
            competencia,
        },
        enabled: empresaId > 0 && !!competencia,
    })
    const [isExportando, setIsExportando] = useState(false)

    const handleExportar = async (pagamentos: TPagamentoFolha) => {
        if (!data?.length) {
            toast.warning('Não há dados para exportar')
            return
        }
        setIsExportando(true)
        return integracaoFolha
            .txt<typeof data>({
                data: data?.map(it => it.id),
                queryParam: {
                    empresaId,
                    competencia,
                    opcoes: JSON.stringify(pagamentos),
                },
            })
            .then(async () => toast.success('Exportado com sucesso'))
            .catch(err => {
                toast.error(err.message)
                throw err
            })
            .finally(() => setIsExportando(false))
    }

    return (
        <Dialog.Root
            height="auto"
            onSubmit={handleExportar}
            defaultValues={{
                horasExtras: '1',
                horasFaltas: '1',
                horasExtrasPagar: '000:00',
                horasFaltasPagar: '000:00',
            }}
            schema={ExportacaoFolhaSchema}
            loading={isExportando}
        >
            <Dialog.Title>
                O que deseja fazer após exportar? ({data?.length} selecionados)
            </Dialog.Title>
            <Dialog.Content dividers>
                {!!historico?.length && (
                    <Alert severity="warning" className="mb-8">
                        <span style={{ marginRight: 20 }}>
                            Já existe um arquivo exportado para esta
                            competência.
                        </span>
                        <Button
                            href="/integracoes/folha-pagamento/historico"
                            variant="outlined"
                            color="warning"
                        >
                            Visualizar histórico
                        </Button>
                    </Alert>
                )}
                <FormExportacaoTxt
                    podeLancarPagamento={
                        empresa?.competenciaAtual == competencia
                    }
                />
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton />
                <Dialog.Actions.PrimaryButton closeOnSubmit>
                    Exportar
                </Dialog.Actions.PrimaryButton>
            </Dialog.Actions>
        </Dialog.Root>
    )
}
